import { useForm } from "react-hook-form"
import { api } from '../../services/api'
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from 'yup'

import styles from './styles.module.scss'

type User = {
    CM_NOME_USUARIO: string;
    CM_SENHA: string;
}

export function Login() {

    const SignupSchema = yup.object().shape({
        CM_NOME_USUARIO: yup.string()
            .required('Insira um email'),
        CM_SENHA: yup.string()
            .required('Insira uma senha')
            .min(8, 'Senha muito curta')
    })

    const {
        register,
        handleSubmit
    } = useForm<User>({ mode: "onChange", resolver: yupResolver(SignupSchema) })

    function onSubmit(userData: User) {
        api.post('/signin', userData)
            .then((resp: any) => {
                localStorage.setItem('userData', JSON.stringify(resp.data))
                window.location.pathname = `${process.env.REACT_APP_BASE_URL}/admin`

                //const jwt =  JSON.parse( localStorage.getItem('userData') || '{}')  
            })
    }

    return (
        <div className={styles.loginContainer}>
            <div className={styles.imageContainer}>
                <img src={`/${process.env.REACT_APP_BASE_URL}/images/loginImage.svg`} alt="teste" />
            </div>
            <div className={styles.formContainer}>
                <form action="" className={styles.form} onSubmit={handleSubmit(onSubmit)}>
                    <h2 className={styles.formTitle}>Bem vindo de volta!</h2>
                    <p className={styles.formSubtitle}>Insira suas credenciais para acessar sua conta</p>

                    <input
                        type="text"
                        className={styles.emailInput}
                        placeholder="Insira o seu email"
                        {...register("CM_NOME_USUARIO")} />
                    <input
                        type="password"
                        className={styles.passwordInput}
                        placeholder="Insira a sua senha"
                        {...register("CM_SENHA")} />

                    <button type="submit" className={styles.button}>Entrar</button>
                </form>
                <p className={styles.formGuide}>Local destinado aos colaboradores da CICOM informática.</p>
            </div>
        </div>
    )
}